<template>
  <div class="Tab">
    <el-table :data="tableData" @selection-change="handleSelectionChange"
      :row-key="getRowKeys" ref="multipleTable">
      <el-table-column :reserve-selection="true" type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column prop="customerCode" :index="NIndex" label="ID" width="200">
      </el-table-column>
      <el-table-column prop="companyName" label="企业名称" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="creditCode" label="统一社会信用代码" width="170" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="联系电话" width="140">
      </el-table-column>
      <el-table-column prop="taxTypeName" label="纳税类型" width="140">
      </el-table-column>
      <el-table-column label="状态" width="140"><template slot-scope="scope">
          <span :style="scope.row.status == 0 ? 'color:#409eff ' : ''">{{
            scope.row.status == -1
              ? "未代理"
              : scope.row.status == 0
                ? "代理中"
                : scope.row.status == 1
                  ? "已过期"
                  : "--"
          }}</span>
        </template></el-table-column>
      <el-table-column label="代理开始/结束月份" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">{{ scope.row.startTime ? scope.row.startTime.slice(0, 7) : "" }}~{{
            scope.row.endTime ? scope.row.endTime.slice(0, 7) : ""
          }}</span>
          <span v-if="scope.row.status == -1">--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right" style="background: #c0c0c0">
        <template slot-scope="scope">
          <span class="span-Operation"
            v-if="JSON.stringify(scope.row.buttonType) === JSON.stringify([0]) && !scope.row.refunding"
            @click="handelPurchase(0, scope.row)">办理代理记账</span>
          <span class="span-Operation" @click="handelPurchase(1, scope.row)" v-if="
            (JSON.stringify(scope.row.buttonType) === JSON.stringify([1]) ||
              JSON.stringify(scope.row.buttonType) === JSON.stringify([1, 2]) ||
              JSON.stringify(scope.row.buttonType) === JSON.stringify([2, 1])) && !scope.row.refunding
          ">续费</span>
          <span class="span-Operation" @click="handelPurchase(2, scope.row)" v-if="
            (JSON.stringify(scope.row.buttonType) === JSON.stringify([2]) ||
              JSON.stringify(scope.row.buttonType) === JSON.stringify([1, 2]) ||
              JSON.stringify(scope.row.buttonType) === JSON.stringify([2, 1])) && !scope.row.refunding
          ">升级</span>
          <span class="span-Operation" v-if="scope.row.canRefund == true && !scope.row.refunding"
            @click="handelRefund(1, scope.row)">申请退款</span>
          <span
            class="span-Operation"
            v-if="scope.row.canRefund == true && !scope.row.refunding"
            @click="handelHesitation(scope.row)"
            >立即办理</span
          >
          <span class="span-Operation" @click="handelAddAndEditor(1, scope.row)" v-if="!scope.row.refunding">编辑</span>
          <span class="span-Operation" style="color: #ff0000" v-if="scope.row.status != 0 && !scope.row.refunding"
            @click="handelDelete(1, scope.row)">删除</span>
          <span class="span-Operation" @click="handelDetails(scope.row)">详情</span>
          <!-- 评价按钮：evaluable为true时显示 -->
          <span
            class="span-Operation"
            v-if="scope.row.evaluable"
            @click="handelEvaluation(scope.row)"
            >评价</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    tableData: {},
    ClearSel: {},
    pagingObj: {},
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {};
  },
  watch: {
    // 监听
    ClearSel: {
      handler(newss, old) {
        this.$refs.multipleTable.clearSelection();
      },
      immediate: false,
    },
  },
  // 组件初始化
  created() { },
  // 组件实例挂载完毕
  mounted() { },
  //销毁事件
  destroyed() { },
  // 组件方法
  methods: {
    // 编辑
    handelAddAndEditor(num, row) {
      this.$emit("handelAddAndEditor", num, row);
    },
    // 删除
    handelDelete(num, row) {
      this.$emit("handelDelete", num, row);
    },
    // 立即退款 申请退款
    handelRefund(num, row) {
      if (!this.$checkAction()) return
      this.$emit("handelRefund", num, row);
    },
    // 立即办理
    handelHesitation(row) {
      if (!this.$checkAction()) return;
      this.$emit("handelHesitation", row);
    },
    // 购买 续费 升级
    handelPurchase(num, row) {
      if (!this.$checkAction()) return
      this.$emit("handelPurchase", num, row);
    },
    // 列表 - 查看
    handelDetails(row) {
      this.$emit("handelDetails", row);
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.$emit("handelEvaluation", row);
    },
    // 列表重新提交
    handelAndLeProcess(num, row) {
      this.$emit("handelAndLeProcess", num, row);
    },
    // 多选
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    getRowKeys(row) {
      return row.id;
    },

    //表格分页序号
    NIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.pagingObj.currentPage; // 当前页码
      const pagesize = this.pagingObj.pageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px;
  /* 主内容区水平滚动条高度 */
}

/* 强制右侧固定列高度与主内容区相同 */
::v-deep .el-table__fixed-right {
  height: 100% !important;
  /* 覆盖默认高度计算 */
}

/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  /* 灰色滑块，比轨道深一些 */
  border-radius: 4px;
  /* 可选：滑块圆角 */
}

// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin;
  /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5;
  /* 滑块色 + 轨道色 */
}

/deep/.el-popover__reference {
  margin-left: 10px !important;
}

.table-box {
  text-align: center;

  p {
    line-height: 25px;
    color: #409eff ;

    text-decoration: underline;
  }
}

.Tab {
  width: 100%;

  .span-Operation {
    color: #409eff ;
    margin-left: 10px;
    cursor: pointer;
  }

  .span-Operation:nth-child(1) {
    margin-left: 0px;
  }
}
</style>
